<template lang="html">
  <div class="blog-product-container">
    <div class="product-image" :style="backgroundImage"></div>
  </div>
</template>

<script>
export default {
  props: {
    product: {
      type: Object,
      required: false
    }
  },

  computed: {
    backgroundImage() {
      return 'background-image: url("' + this.product.featured_image + '")';
    }
  }
};
</script>

<style lang="scss" scoped>
@import "~@/styles/_colour-palette.scss";
@import "~@/styles/_breakpoints.scss";

.blog-product-container {
  margin: 15px;

  .product-image {
    background-repeat: no-repeat;
    background-size: contain;
    background-position: center;
    width: 200px;
    height: 240px;

    &:hover {
      border: 1px solid rgba(169, 169, 169, 0.2);
      box-shadow: 0px 5px 5px 0px rgba(169, 169, 169, 1);
    }

    @include for-tablet-portrait-up {
      width: 210px;
      height: 250px;
    }

    @include for-tablet-landscape-up {
      width: 200px;
      height: 240px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/blogEntry/BlogGroupProduct.vue